/* eslint-disable no-prototype-builtins */
import React, { useEffect } from 'react';
import { Grid, Paper, Stack, Typography } from '@esgian/esgianui';
import { PercentageLoadPerEngineChart } from '@components/Charts';
import EnginePercentageLoadChart from '../../Charts/EnginePercentageLoadChart';
import PowerDetailsWrapper from '@components/Sections/PowerMgmtSection/PowerDetailsWrapper';
import { setChartSelectedDate } from '@store/features/filters/MainPageSlice/MainPageSlice';
import { useTimezone } from '@hooks/useTimezone';
import { useMainPageQueries } from '@hooks/usePageQueries/useMainPageQueries';
import { getMainPageSlice } from '@store/features/filters/MainPageSlice/MainPageSlice';
import { TextWithTooltipIcon } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { findSignal } from '@api/helpers';

function PowerMgmtSection() {
  const dispatch = useDispatch();

  const { selectedTimeZone } = useTimezone();
  const { rigPowerMgmtQuery } = useMainPageQueries();
  const { chartSelectedDate } = useSelector(getMainPageSlice);

  useEffect(() => {
    if (!rigPowerMgmtQuery.data || !rigPowerMgmtQuery.data?.signals) return;
    const { signals } = rigPowerMgmtQuery.data;
    const engOnSignal = findSignal(signals, 'EngOn');
    const EngOn = engOnSignal?.timeSeriesValues || {};
    
    if (!chartSelectedDate) {
      dispatch(
        setChartSelectedDate({
          index: 0,
          date: Object.keys(EngOn)?.[0],
          isLast: false
        })
      );
    }
  }, [rigPowerMgmtQuery.data, selectedTimeZone]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={3.5}>
        <Paper>
          <Stack sx={{ pl: 2, pt: 2 }}>
            <TextWithTooltipIcon
              tooltipText={`Average engine load for each engine in the selected time period while running and the average SFOC value.
SFOC is the Specific Fuel Oil Consumption. The SFOC value indicates how much fuel is used to produce 1 kwh.
This value is calculated from the engines fuel consumption divided by the energy produced.
In general engine load 80-90% will give the lowest (best) SFOC value.`}
              label={<Typography variant={'h6'}>Engines summary</Typography>}
            />
            <Typography variant={'body2'}>Average engine load and SFOC in the period</Typography>
          </Stack>
          <PercentageLoadPerEngineChart
            loading={rigPowerMgmtQuery.isFetching}
            powerMgmtData={rigPowerMgmtQuery.data}
          />
        </Paper>
      </Grid>
      <Grid item xs={8.5}>
        <Paper sx={{ pl: 2, pt: 2, pr: 2 }}>
          <Stack spacing={1} id={'engine-overview-section'}>
            <Stack>
              <TextWithTooltipIcon
                tooltipText={`Average engine load for all online engines per day, and the average number of engines online per day. Clicking on one of the bars will reveal the details per hour for the day before, selected day and the next day in the graphs below.`}
                label={<Typography variant={'h6'}>Engines overview</Typography>}
              />
              <Typography variant={'body2'}>Daily average engine load</Typography>
            </Stack>
            <EnginePercentageLoadChart
              selectedDate={chartSelectedDate}
              loading={rigPowerMgmtQuery.isFetching}
              powerMgmtData={rigPowerMgmtQuery.data}
              setSelectedDate={(v) => dispatch(setChartSelectedDate(v))}
            />
          </Stack>
          <PowerDetailsWrapper
            loading={rigPowerMgmtQuery.isFetching}
            selectedDate={chartSelectedDate}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}
PowerMgmtSection.propTypes = {};

PowerMgmtSection.defaultProps = {};

export default PowerMgmtSection;
